import { render, staticRenderFns } from "./EntryDetail.vue?vue&type=template&id=4dba7cbf&scoped=true"
import script from "./EntryDetail.vue?vue&type=script&lang=js"
export * from "./EntryDetail.vue?vue&type=script&lang=js"
import style0 from "./EntryDetail.vue?vue&type=style&index=0&id=4dba7cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dba7cbf",
  null
  
)

export default component.exports